module.exports = __webpack_public_path__ + "img/brook_rd_b1.6884de0b.jpg";